import { 
  extractBasicData, 
  extractClientData, 
  extractOperatorData, 
  extractProjectData, 
  extractStatusData, 
  extractDateData, 
  extractAdditionalData 
} from './ordensServicoDataExtractor';
import { validateApiData } from './ordensServicoValidation';

export interface NormalizedData {
  id: string;
  numero: string;
  cliente: string;
  operador: string;
  produto: string;
  projeto: string;
  projetoFechado: boolean;
  status: string;
  natureza: string;
  dataAbertura: string;
  dataFechamento?: string;
  observacoes: string;
  tipoProjeto: string;
  tipoChamado: string;
  incluidoPor: string;
  estatisticasChamado: any;
  contato: string;
  dataFormatada: string;
}

export const normalizeApiData = (apiData: any): NormalizedData => {
  validateApiData(apiData);

  const { id, numero } = extractBasicData(apiData);
  const { cliente } = extractClientData(apiData);
  const { operador } = extractOperatorData(apiData);
  const { produto, projeto, projetoFechado } = extractProjectData(apiData);
  const { status, natureza } = extractStatusData(apiData);
  const { dataAbertura, dataFechamento } = extractDateData(apiData);
  const { observacoes, tipoProjeto, tipoChamado, incluidoPor, estatisticasChamado, contato } = extractAdditionalData(apiData);

  const dataFormatada = apiData?.data?.formatada || '';

  return {
    id,
    numero,
    cliente,
    operador,
    produto,
    projeto,
    projetoFechado,
    status,
    natureza,
    dataAbertura,
    dataFechamento,
    observacoes,
    tipoProjeto,
    tipoChamado,
    incluidoPor,
    estatisticasChamado,
    contato,
    dataFormatada
  };
};
